export default __webpack_public_path__ + "static/media/Background_00237.5b56a39e.png";